<!--大屏展示 全页面-->
<template>

  <div class="img-box">
    <baidu-map :center="center" :zoom="zoom" @ready="handler" style="height:100%" :min-zoom="minzoom" :max-zoom="maxzoom"
               :scroll-wheel-zoom='true' :mapType="mapType">
      <bm-geolocation anchor="BMAP_ANCHOR_TOP_LEFT" :showAddressBar="true" :autoLocation="true"></bm-geolocation>
    </baidu-map>

    <LargerScreen></LargerScreen>
  </div>
</template>

<script>
  import LargerScreen from '../../components/largerScreen'


  import {  _getProductData,_getThingModels,_getDevices,_getDevicePropData,_getDevicePropDataTop } from '@/common/request'
  import device from '@/store/modules/device'
  export default {
    name: 'LargerScreenPage',
    components: {
      LargerScreen


    },
    data() {
      return {
        center: {lng:119, lat: 48},
        zoom: 17,//最高20
        minzoom:1,
        maxzoom:20,
        mapType:"BMAP_SATELLITE_MAP",
        addressKeyword:"保利春天派",
        points:[],
        deviceData:{},
        deviceDataDetail:{},
        deviceshow:false,
        map:null,
        BMap:null,
        queryInfo:{cEntID:""},
        queryDetailInfo:{},
        devicelist:[],
        timer:null,

        backButton:"",

        setDeviceProParam:{
          productKey:"",
          devicename:"",
          IotId:"",
          inputParam:{}
        }
      }
    },
    mounted () {
      let that=this;
      that.timer=setInterval(function(){that.InterlEvent(that.BMap,that.map)},10000);
      window['TabImg'] = (obj,io,value) => {
        this.TabImg(obj,io,value)
      }
      window['CloseImg']=()=>{
        this.CloseImg()
      }
      this.queryInfo.cEntID= this.$store.getters.User.enterprise.ID;


    },
    methods: {

      async handler ({BMap, map}) {
        let that=this;
        that.map=map;

        that.BMap=BMap;
        this.center.lng = this.$store.getters.User.enterprise.cLongitude
        this.center.lat = this.$store.getters.User.enterprise.cLatitude

        const res =await _getDevices(that,that.queryInfo)
        if(res.code==200){
          that.devicelist=res.obj.list;

        }
        if (that.devicelist&&that.devicelist.length>0){
          for (var i=0;i<that.devicelist.length;i++){
            if (that.devicelist[i].cLongitude&&that.devicelist[i].cLatitude){


              let Product= that.$store.getters.Products.filter(item => item.ProductKey==that.devicelist[i].ProductKey)[0];

              if (Product&&Product.cIcon){

                that.points.push([that.devicelist[i].cLongitude,that.devicelist[i].cLatitude,that.devicelist[i],Product.cIcon]);
              }else {
                that.points.push([that.devicelist[i].cLongitude,that.devicelist[i].cLatitude,that.devicelist[i], "../../img/deviceicon.png"]);

              }

            }
          }
        }else {

        }


        that.points.forEach((ele,index)=>{
          console.log('ele',ele);
          console.log('ele[3] url',ele[3]);
var url=ele[3];
ele[2].sicon=url;
url=require("../../img/deviceicon.png");
       //   console.log('ele url',url);
          let myIcon2 = new BMap.Icon(url,new BMap.Size(40, 68), {
            // 指定定位位置
            offset: new BMap.Size(0, 0),
            // 当需要从一幅较大的图片中截取某部分作为标注图标时，需要指定大图的偏移位置
            imageOffset: new BMap.Size(0, 0) // 设置图片偏移
          })
          var pointi=new BMap.Point(ele[0], ele[1]);
          var markei = new BMap.Marker(pointi,{icon: myIcon2}) // 创建标注
          map.centerAndZoom(pointi, this.zoom)
          let label = new BMap.Label(ele[2], {offset: new BMap.Size(20, 0)});
          label.setStyle({display:"none"});
          markei.setLabel(label);  //把label设置到maker上

          markei.addEventListener("click",async function (event) {
            //每个设备对象
            let dData=event.target.getLabel().content;

            that.openInfo(dData,function (str) {
              var infoBox = new BMapLib.InfoBox(map,str,{
                boxStyle:{
                  width: "300px"
                  ,height: "400px"
                }
                ,closeIconMargin: "1px 1px 0 0"
                ,closeIconUrl: null
                ,enableAutoPan: false
                ,align: 1

              });


              if(that.lastInfoBox){

                that.lastInfoBox.close();
              }
              that.lastInfoBox = infoBox;
              that.lastInfoBox.open(markei);


            })
          });
          map.addOverlay(markei) // 将标注添加到地图中
        })

      },
      async InterlEvent(BMap,map){

        let that=this;
        that.queryInfo.devicename="";
        that.queryInfo.productkey="";
        that.queryInfo.IotId="";
        const res =await _getDevices(that,that.queryInfo)
        if(res.code==200){
          that.devicelist=res.obj.list;

        }



        var newpoints=[];
        that.devicelist.forEach((ele,index)=>{
          if (ele.cLongitude&&ele.cLatitude) {
            let Product= that.$store.getters.Products.filter(item => item.ProductKey==ele.ProductKey)[0];

            if (Product&&Product.cIcon){

              newpoints.push([ele.cLongitude,ele.cLatitude,ele,Product.cIcon]);
            }else {
              newpoints.push([ele.cLongitude,ele.cLatitude,ele, "../../img/deviceicon.png"]);

            }

          }
        });
        if (newpoints&&newpoints.length!=that.points.length){
          that.points=newpoints;
          map.clearOverlays();
          that.points.forEach((ele,index)=>{
            var url=require(ele[3]);
            let myIcon2 = new BMap.Icon(url,new BMap.Size(40, 68), {
              // 指定定位位置
              offset: new BMap.Size(0, 0),
              // 当需要从一幅较大的图片中截取某部分作为标注图标时，需要指定大图的偏移位置
              imageOffset: new BMap.Size(0, 0) // 设置图片偏移
            })
            let pointi = new BMap.Point(ele[0], ele[1])


            map.centerAndZoom(pointi, this.zoom)

            var markei = new BMap.Marker(pointi,{icon: myIcon2}) // 创建标注
            let label = new BMap.Label(ele[2], {offset: new BMap.Size(20, 0)});
            label.setStyle({display:"none"});
            markei.setLabel(label);  //把label设置到maker上
            markei.addEventListener("click",async function (event) {
              //每个设备对象
              let dData=event.target.getLabel().content;
              that.openInfo(dData,function (str) {
                var infoBox = new BMapLib.InfoBox(map,str,{
                  boxStyle:{
                    width: "300px"
                    ,height: "400px"
                  }
                  ,closeIconMargin: "1px 1px 0 0"
                  ,closeIconUrl: null
                  ,enableAutoPan: false
                  ,align: 1

                });


                if(that.lastInfoBox){

                  that.lastInfoBox.close();
                }
                that.lastInfoBox = infoBox;
                that.lastInfoBox.open(markei);


              })
            });
            map.addOverlay(markei) // 将标注添加到地图中
          })
        }


      },
      openInfo(data,callback){
        let that=this;

        that.getDeviceDetial(data,callback);


      },
      //开关控制
      async deviceControl(obj,item,value){
        var param='"'+item+'":'+value

        this.setDeviceProParam.productKey= this.queryDetailInfo.productkey
        this.setDeviceProParam.devicename= this.queryDetailInfo.devicename
        this.setDeviceProParam.IotId=this.queryDetailInfo.IotId
        this.setDeviceProParam.inputParam='{'+param+'}'

        const {data:res} = await this.$http.post('WLWDevice/SetDeviceProperty',this.setDeviceProParam)
        if(res.code=="200"){

          this.$message.success(res.message)
          if (value>=1){
            obj.src=require('../../img/openIcon.png')

          }
          else {
            obj.src=require('../../img/closeIcon.png')
          }
        }
        else{
          this.$message.error(res.message)
        }

      },
      //获取设备
      async  getDeviceDetial(deviceData,callback){

        let that=this;

        that.queryDetailInfo.productkey=deviceData.ProductKey;
        that.queryDetailInfo.devicename=deviceData.DeviceName;
        that.queryDetailInfo.IotId=deviceData.IotId;
        console.log(111);
        console.log(deviceData);
        var ThingModels=that.$store.getters.ThingModels.filter(x=>x.productKey==deviceData.ProductKey)
        console.log(that.$store.getters.ThingModels);
        if(ThingModels!=null && ThingModels.length>0){
          var propertiesR=that.utils.deepClone(ThingModels[0].propertiesR)
if(propertiesR!=null&&propertiesR.length>0)
          deviceData.propertiesR=propertiesR.splice(0,6)

          deviceData.propertiesW=that.utils.deepClone(ThingModels[0].propertiesW)
if( deviceData.propertiesW!=null&& deviceData.propertiesW.length>0)
          deviceData.propertiesW=deviceData.propertiesW.slice(0,6);


        }

        var data=await _getDevicePropData(this,{limit:1,productkey:deviceData.ProductKey,devicename:deviceData.DeviceName})

        if(data.code=="200" && data.obj.list.length>0)
        {
          var dataItems=data.obj.list[0].dataItems
          if(  deviceData.propertiesR!=null&&  deviceData.propertiesR.length>0)
          deviceData.propertiesR.forEach(element => {
            if(dataItems[element.identifier]!=null){
              var value=that.utils.formatPropData(element,dataItems[element.identifier].value)

              that.$set(element,"dataValue",value)
            }
          })
if(deviceData&&deviceData.propertiesW&&deviceData.propertiesW.length>0)
          deviceData.propertiesW.forEach(element => {

            if(dataItems[element.identifier]!=null){
              var value=that.utils.formatPropData(element,dataItems[element.identifier].value,false)

              that.$set(element,"dataValue",value)
            }
            else{
              that.$set(element,"dataValue",0)

            }
          })
        }
        let bgimg=require("../../img/lshebeiBg.png")
        let bgimg2=require("../../image/homePage/famen.png")
if(deviceData.sicon!='')bgimg2=deviceData.sicon;
        console.log('deviceData:::',deviceData);

        var str= `<div class="lm-w-all-box"><div class="lm-all-box" >

     <div class="lm-img-box"><img src="${bgimg}" alt="" width="100%"></div>
     <div class="lm-content-title">
        <img class="famen-icon" src="${bgimg2}" /><div style="margin-left: 20px;">
${deviceData.DeviceAsName}-${deviceData.DeviceName}
</div></div>
     <div class="lm-close-box"  onclick="CloseImg()">×</div>
     <div class="lm-cgq-box">`
        console.log('!deviceData.propertiesR',!deviceData.propertiesR);
        if(!deviceData.propertiesR){
          deviceData.properties=[];
        }
        let propertiesRs;
        try{ propertiesRs=that.utils.deepClone(deviceData.propertiesR)
        }
        catch (e) {

        }
       if(propertiesRs!=null&&propertiesRs.length>0)
        propertiesRs.forEach((ele,index)=>{

          str+=`<div class="lm-content-single-box"> ${ele.name}：${ele.dataValue==null?'无':ele.dataValue}</div>`;
        })
        str+=`</div><div class="lm-zxq-box">`;
        if (!deviceData.propertiesW){
          deviceData.propertiesW=[];
        }
        let propertiesWs=Object.assign(deviceData.propertiesW,[]);
        propertiesWs.forEach((ele,index)=>{
          let opensrc=require("../../img/openIcon.png")
          let closesrc=require("../../img/closeIcon.png")
          let identifier="'"+ele.identifier+"'";

          if(ele.dataValue>=1){
            str+=`<div class="lm-content-single-box"><span>${ele.name}</span><img onclick="TabImg(this,${identifier},0)" src="${opensrc}" alt="" class="lss-bottom-single-img"></div>`;
          }else   {
            str+=`<div class="lm-content-single-box"><span>${ele.name}</span><img onclick="TabImg(this,${identifier},1)" src="${closesrc}" alt="" class="lss-bottom-single-img"></div>`;
          }

        })
        str+="</div></div></div>"

        callback(str);
      },
      TabImg(obj,item,value){
        let that=this;

        that.deviceControl(obj,item,value)

      },
      CloseImg(){
        this.lastInfoBox.close();
      },
      async getProductData(){
        await _getProductData(this,JSON.stringify(this.queryInfo))
      },
      async getDevicePropData(param){
        const res=await _getDevicePropData(this,param)
        if(res!=null){
          return res.obj.list
        }
        else{
          this.$message.error(res.message)
          return new []
        }
      }

    },
    beforeDestroy () {
      clearInterval(this.timer)
    }
  }
</script>

<style>
  @import 'largerScreen.css';


  .BMap_cpyCtrl {
    display: none;
  }

  .anchorBL {
    display: none;}

</style>

<style>
  .button{
    position: absolute;
    top: 85%;
    left:82%;
  }
  .sl-cgq-single-x{

    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 90%;
    /*margin: 16px 0;*/
    /*align-items*/
    color: rgba(255,255,255,0.7);
    z-index: 99;
    margin: 5px 0;

  }
  .button-img-box{

    height: 60px;
    width: 210px;
  }
  .updata{
    position: absolute;
    top: 32%;
    left: 33%;
  }
  .img-box {
    width: 100%;
    position: absolute;
    top: 70px;
    bottom: 0;
  }
  .sl-cgq-single-box {
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 90%;
    /*margin: 16px 0;*/
    /*align-items*/
    color: rgba(255, 255, 255, 0.7);
    z-index: 99;
  }
  .left-big-box {
    position: absolute;
    top: 70px;
    bottom: 0;
    /* height: 100%; */
    width: 25%;
    background-color:rgba(0, 33, 64, 0.7);
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
  }
  .left-small-box {
    width: 90%;
    background-color: rgba(10, 45, 87, 0.8);
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    border-radius: 5px;
  }
  .top-box {
    width: 100%;
    display: flex;
    align-content: flex-end;
    justify-content: flex-end;
    flex-direction: row;
    align-items: flex-end;
    /* justify-content: space-between; */

    height: 20%;
  }
  .heng-line {
    width: 100%;
    height: 1px;
    background-color: #075a8c;
  }
  .top-big-text {
    font-size: 115%;
    color: #1587e0;
    margin-left: 20px;
    width: 23%;
  }
  .top-right-box {
    margin-left: 10px;
    width: 60%;
  }
  .top-small-text {
    font-size: 80%;
    color: #075a8c;
    position: absolute;
    top: 5%;
    left: 80%;
    /* margin-left: 180px; */

  }
  .bottom-box {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    align-content: center;
    font-size: 80%;
    height: 80%;
  }
  .bottom-small-box {
    display: flex;
    flex-direction: column;
    width: 25%;
    height: 45%;
    justify-content: space-around;
    align-items: center;
    color: #ffffff;
  }
  .bottom-top-text {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .bottom-box-mid {
    width: 90%;
    height: 80%;
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    color: #ffffff;
    align-content: center;
    align-items: center;
    font-size: 80%;
  }
  .bottom-left-biao-box {
    display: flex;
    flex-direction: row;
  }
  .image-box {
    width: 100%;
    height: 120%;
  }
  .bottom-left-text {
    height: 149%;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .bottom-left-text-scen {
    font-size: 8px;
  }
  .time {
    display: flex;
    flex-direction: row;
    margin-left: 13%;
    margin-top: 9%;
    width: 85%;
  }
  .bottom-box-third {
    width: 90%;
    height: 80%;
    display: flex;
    align-items: center;
    align-content: center;
    flex-direction: column;
    justify-content: space-around;
    color: #ffffff;
  }
  .bottom-box-third-text {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 250px;
    /* margin-left: -10px; */
  }
  .bottom-box-third-line {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    width: 357px;
    border-radius: 5px;
    height: 45px;
    text-align: center;
    line-height: 45px;
  }
  .bottom-box-third-line-x {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    width: 110%;
    border-radius: 5px;
    height: 45px;
    text-align: center;
    line-height: 45px;
    background-image: linear-gradient(
      rgba(2, 53, 96, 0.2),
      rgba(21, 96, 136, 0.5)
    );
  }
  .time-minute {
    /* padding-left: -20px; */
    /* width: 20px; */
  }
  .icon-box {
    height: 35px;
    width: 35px;
  }
  .bottom-top-dan-text {
    font-size: 50%;
  }
  .bottom-name-text {
    font-size: 10px;
  }
  .bottom-top-title {
    font-size: 13px;
  }
  .shu-icon {
  }

  /* youce */
  .right-tan-box {
    position: absolute;
    right: 100px;
    top: 120px;
    color: #ffffff;
  }
  .right-tan-box-x {
    position: absolute;
    right: 500px;
    top: 120px;
    color: #ffffff;
  }
  .background {
    height: 290px;
    width: 280px;
  }
  .top-famen {
    display: flex;
    flex-direction: row;
    color: #ffffff;
    height: 40px;
    line-height: 40px;
   /* justify-content: center;*/
    align-content: center;
    position: absolute;
    top: 5px;
    left: 40px;
    z-index: 99;
  }



  .famen-icon {
    height: 40px;
    width: 40px;
    margin-left:10px ;
  }
  /* .container-big-box{height: 130px;width: 200px;display: flex;flex-direction: column;position: absolute;left: 40px;top:80px;display: flex;justify-content: space-around;} */
  .container-small-line {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .container-small-line-t {
    display: flex;
    flex-direction: row;
    margin-left: -20px !important;
  }
  .container-line {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .container-img {
    height: 18px;
    width: 18px;
  }
  .title {
    margin-left: 5px;
  }
  .shut {
    position: absolute;
    top: 225px;
    left: 100px;
    height: 30px;
    width: 80px;
  }
  .container-big-box {
    position: absolute;
    left: 30px;
    top: 100px;
    width: 80%;
    height: 40%;
    display: flex;
    /*border: 1px solid #ffffff;*/
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }
  .sl-cgq-single{display:flex;flex-direction:row;justify-content: space-between; position: absolute; left: 45px; width: 70%;
    top: 70px;align-content: center;}
  .seemore{
    font-size: 90%;
    color:#075a8c ;
  }
  .bottom-hot-box{
    width: 98%;
    height: 80%;
    position: relative;
    top:-206px;
    display: flex;
    /*border: 1px solid #ffffff;*/
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;

  }



  .lm-close-box{
    color: white;
    position: absolute;
    top:2%;
    left: 86.5%;
    font-size: 130%;
    font-weight: bold;
    z-index: 20;
    cursor: pointer;
  }
  .lm-w-all-box{
    position: relative;
  }
  .lm-all-box{
    position: absolute;
    z-index: 15;
    top:1%;
    /*left: 15%;*/
    width: 350px;
  }

  .lm-img-box{
    width: 100%;
  }

  .lm-content-title{
    position: absolute;
    top:2%;
    left: 10%;
    /*border:1px solid #ffffff;*/
    width: 80%;
    height: 17%;
    color: #ffffff;
    display: flex;
/*    justify-content: center;*/
    align-items: center;
  }

  .lm-content-box{
    position: absolute;
    top:23%;
    left: 2%;
    /*border:1px solid #ffffff;*/
    width: 96%;
    height: 77%;
    display: flex;
    flex-direction: column;
    /*flex-wrap: wrap;*/
    padding: 5% 2% 0;
  }

  .lm-content-single-box{
    color: #ffffff;
    width: 50%;
    text-align: center;
    font-size: 85%;
  }

  .lm-cgq-box{
    position: absolute;
    top:23%;
    left: 2%;
    /*border:1px solid #ffffff;*/
    width: 96%;
    height: 33%;
    display: flex;
    flex-wrap: wrap;
    padding: 5% 2% 0;
  }

  .lm-zxq-box{
    position: absolute;
    top:56%;
    left: 2%;
    /*border:1px solid #ffffff;*/
    width: 96%;
    height: 33%;
    display: flex;
    flex-wrap: wrap;
    padding: 5% 2% 0;
  }
</style>

